import { ElementRef, EventEmitter, TemplateRef } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JhiLanguageService } from '../../ng-jhipster/language';
import { AutomatedMessageService } from '../../entities/automated-message/automated-message.service';
import { AutomatedMessage } from '../../shared/model/admin/automated-message.model';
import { AlertModalComponent } from '../../shared/alert/alert-modal.component';
import { CoachDto } from '../../shared/model/coach-dto.model';
import { User } from '../../core/user/user.model';
import { CoachEducation } from '../../shared/model/coach-education.model';
import { CoachReasoning } from '../../core/user/coach-reasoning.model';
import { FormBuilder, Validators } from "@angular/forms";
import { BaseComponent } from '../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { UserService } from '../../core/user/user.service';
import { LANGUAGES } from '../../app.constants';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../ng-jhipster/language";
import * as i4 from "../../entities/automated-message/automated-message.service";
import * as i5 from "@angular/forms";
import * as i6 from "../../core/user/user.service";
import * as i7 from "@angular/common";
import * as i8 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "@fortawesome/angular-fontawesome";
import * as i10 from "../../shared/alert/alert-error.component";
import * as i11 from "@angular/material/form-field";
import * as i12 from "@angular/material/input";
import * as i13 from "../../shared/coach-bio/coach-bio.component";
import * as i14 from "@ngx-translate/core";
const _c0 = ["coachBioModal"];
const _c1 = ["educationModal"];
const _c2 = ["educationDeletionConfirmation"];
const _c3 = ["messageTooShortModal"];
const _c4 = ["automatedMessageText"];
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 26);
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 27);
} }
const _c5 = function (a0) { return { "color": a0 }; };
function CoachWelcomeAutomatedMessageComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "textarea", 30);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_div_1_div_7_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.coachReasoning.coachReasoningText = $event; });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵelementStart(5, "small", 32);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("height", ctx_r12.windowWidth < 576 ? "295px" : "132px");
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 7, "settings.placeholder.whyDoICoach"))("ngModel", ctx_r12.coachReasoning.coachReasoningText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c5, ctx_r12.getColor(ctx_r12.coachReasoning.coachReasoningText, ctx_r12.charLimitWhyDoICoach)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r12.coachReasoning.coachReasoningText.length, " / ", ctx_r12.charLimitWhyDoICoach, " ");
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 26);
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 27);
} }
function CoachWelcomeAutomatedMessageComponent_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "textarea", 30);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_div_1_div_14_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.coachReasoning.experiences = $event; });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵelementStart(5, "small", 32);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("height", ctx_r15.windowWidth < 576 ? "295px" : "132px");
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 7, "settings.placeholder.myExperience"))("ngModel", ctx_r15.coachReasoning.experiences);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c5, ctx_r15.getColor(ctx_r15.coachReasoning.experiences, ctx_r15.charLimitMyExperience)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r15.coachReasoning.experiences.length, " / ", ctx_r15.charLimitMyExperience, " ");
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 26);
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 27);
} }
function CoachWelcomeAutomatedMessageComponent_div_1_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "textarea", 33);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_div_1_div_21_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.coachReasoning.iceBreakers = $event; });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵelementStart(5, "small", 32);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("height", ctx_r18.windowWidth < 576 ? "295px" : "132px");
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 7, "settings.placeholder.iceBreakers"))("ngModel", ctx_r18.coachReasoning.iceBreakers);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c5, ctx_r18.getColor(ctx_r18.coachReasoning.iceBreakers, ctx_r18.charLimitIcebreakers)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r18.coachReasoning.iceBreakers.length, " / ", ctx_r18.charLimitIcebreakers, " ");
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 26);
} }
function CoachWelcomeAutomatedMessageComponent_div_1__svg_use_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 27);
} }
function CoachWelcomeAutomatedMessageComponent_div_1_span_28_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelementStart(2, "div", 36);
    i0.ɵɵelementStart(3, "fa-icon", 37);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_span_28_ng_container_1_Template_fa_icon_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const ce_r29 = restoredCtx.$implicit; const ctx_r30 = i0.ɵɵnextContext(3); return ctx_r30.confirmDeleteEducation(ce_r29); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_span_28_ng_container_1_Template_div_click_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const ce_r29 = restoredCtx.$implicit; const ctx_r32 = i0.ɵɵnextContext(3); return ctx_r32.editEducation(ce_r29); });
    i0.ɵɵelementStart(5, "p", 39);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p", 40);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 41);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ce_r29 = ctx.$implicit;
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r28.windowWidth < 1200 ? "96%" : "48%");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ce_r29.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ce_r29.school);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ce_r29.year);
} }
function CoachWelcomeAutomatedMessageComponent_div_1_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, CoachWelcomeAutomatedMessageComponent_div_1_span_28_ng_container_1_Template, 11, 5, "ng-container", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r21.coachReasoning.educations);
} }
function CoachWelcomeAutomatedMessageComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelement(3, "h4", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 13);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_Template__svg_svg_click_4_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.showWhyDoICoach = !ctx_r33.showWhyDoICoach; });
    i0.ɵɵtemplate(5, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_5_Template, 1, 0, "use", 14);
    i0.ɵɵtemplate(6, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_6_Template, 1, 0, "use", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CoachWelcomeAutomatedMessageComponent_div_1_div_7_Template, 7, 11, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "div", 10);
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵelement(10, "h4", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(11, "svg", 13);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_Template__svg_svg_click_11_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.showMyExperience = !ctx_r35.showMyExperience; });
    i0.ɵɵtemplate(12, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_12_Template, 1, 0, "use", 14);
    i0.ɵɵtemplate(13, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_13_Template, 1, 0, "use", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CoachWelcomeAutomatedMessageComponent_div_1_div_14_Template, 7, 11, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵelementStart(16, "div", 11);
    i0.ɵɵelement(17, "h4", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(18, "svg", 13);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_Template__svg_svg_click_18_listener() { i0.ɵɵrestoreView(_r34); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.showIcebreakers = !ctx_r36.showIcebreakers; });
    i0.ɵɵtemplate(19, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_19_Template, 1, 0, "use", 14);
    i0.ɵɵtemplate(20, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_20_Template, 1, 0, "use", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, CoachWelcomeAutomatedMessageComponent_div_1_div_21_Template, 7, 11, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(22, "div", 10);
    i0.ɵɵelementStart(23, "div", 11);
    i0.ɵɵelement(24, "h4", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(25, "svg", 13);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_Template__svg_svg_click_25_listener() { i0.ɵɵrestoreView(_r34); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.showEducationCredentials = !ctx_r37.showEducationCredentials; });
    i0.ɵɵtemplate(26, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_26_Template, 1, 0, "use", 14);
    i0.ɵɵtemplate(27, CoachWelcomeAutomatedMessageComponent_div_1__svg_use_27_Template, 1, 0, "use", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(28, CoachWelcomeAutomatedMessageComponent_div_1_span_28_Template, 2, 1, "span", 20);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(29, "p", 21);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_Template_p_click_29_listener() { i0.ɵɵrestoreView(_r34); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.openEducationModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 22);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_1_Template_div_click_30_listener() { i0.ɵɵrestoreView(_r34); const ctx_r39 = i0.ɵɵnextContext(); return ctx_r39.displayCoachBio(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(31, "svg", 23);
    i0.ɵɵelement(32, "use", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(33, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.showWhyDoICoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.showWhyDoICoach);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showWhyDoICoach);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.showMyExperience);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.showMyExperience);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showMyExperience);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.showIcebreakers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.showIcebreakers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showIcebreakers);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.showEducationCredentials);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.showEducationCredentials);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showEducationCredentials);
} }
function CoachWelcomeAutomatedMessageComponent_div_2__svg_use_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 26);
} }
function CoachWelcomeAutomatedMessageComponent_div_2__svg_use_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 27);
} }
function CoachWelcomeAutomatedMessageComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "textarea", 44);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_div_2_div_8_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.automatedMessage.text = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 31);
    i0.ɵɵelementStart(4, "small", 32);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("height", "295px");
    i0.ɵɵproperty("ngModel", ctx_r42.automatedMessage.text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(6, _c5, ctx_r42.getColor(ctx_r42.automatedMessage.text, ctx_r42.charLimitWelcomeMessage)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r42.automatedMessage.text.length, " / ", ctx_r42.charLimitWelcomeMessage, " ");
} }
function CoachWelcomeAutomatedMessageComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelement(3, "h4", 42);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 13);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_div_2_Template__svg_svg_click_4_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.showWelcomeMessage = !ctx_r45.showWelcomeMessage; });
    i0.ɵɵtemplate(5, CoachWelcomeAutomatedMessageComponent_div_2__svg_use_5_Template, 1, 0, "use", 14);
    i0.ɵɵtemplate(6, CoachWelcomeAutomatedMessageComponent_div_2__svg_use_6_Template, 1, 0, "use", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(7, "p", 43);
    i0.ɵɵtemplate(8, CoachWelcomeAutomatedMessageComponent_div_2_div_8_Template, 6, 8, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.showWelcomeMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.showWelcomeMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showWelcomeMessage);
} }
const _c6 = function (a0) { return { language: a0 }; };
function CoachWelcomeAutomatedMessageComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "fa-icon", 46);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_5_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelementStart(4, "div", 48);
    i0.ɵɵelement(5, "p", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 50);
    i0.ɵɵelementStart(7, "div", 51);
    i0.ɵɵelementStart(8, "button", 52);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_5_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r49); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.submit(); });
    i0.ɵɵelement(9, "span", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 51);
    i0.ɵɵelementStart(11, "button", 54);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_5_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r49); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.close(); });
    i0.ɵɵelement(12, "span", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 56);
    i0.ɵɵelementStart(14, "div", 57);
    i0.ɵɵelementStart(15, "button", 58);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_5_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r49); const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.submit(); });
    i0.ɵɵelement(16, "span", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 59);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_5_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r49); const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.close(); });
    i0.ɵɵelement(18, "span", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c6, ctx_r3.entityLanguage));
} }
function CoachWelcomeAutomatedMessageComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "fa-icon", 46);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_7_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵelement(5, "h4", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "form", 62);
    i0.ɵɵlistener("ngSubmit", function CoachWelcomeAutomatedMessageComponent_ng_template_7_Template_form_ngSubmit_6_listener() { i0.ɵɵrestoreView(_r56); const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.updateEducation(); });
    i0.ɵɵelementStart(7, "div", 0);
    i0.ɵɵelementStart(8, "div", 63);
    i0.ɵɵelementStart(9, "div", 29);
    i0.ɵɵelementStart(10, "mat-form-field", 64);
    i0.ɵɵelementStart(11, "mat-label");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "input", 65);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_ng_template_7_Template_input_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r56); const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.coachEducation.title = $event; });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "mat-form-field", 64);
    i0.ɵɵelementStart(17, "mat-label");
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "input", 66);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_ng_template_7_Template_input_ngModelChange_20_listener($event) { i0.ɵɵrestoreView(_r56); const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.coachEducation.school = $event; });
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "mat-form-field", 64);
    i0.ɵɵelementStart(23, "mat-label");
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "input", 67);
    i0.ɵɵlistener("ngModelChange", function CoachWelcomeAutomatedMessageComponent_ng_template_7_Template_input_ngModelChange_26_listener($event) { i0.ɵɵrestoreView(_r56); const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.coachEducation.year = $event; });
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 68);
    i0.ɵɵelement(29, "button", 69);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("formGroup", ctx_r5.educationForm);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 10, "settings.placeholder.degree"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(15, 12, "settings.placeholder.egCertificate"));
    i0.ɵɵproperty("ngModel", ctx_r5.coachEducation.title);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 14, "settings.placeholder.school"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 16, "settings.placeholder.egSchool"));
    i0.ɵɵproperty("ngModel", ctx_r5.coachEducation.school);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 18, "settings.placeholder.year"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(27, 20, "settings.placeholder.egYear"));
    i0.ɵɵproperty("ngModel", ctx_r5.coachEducation.year);
} }
function CoachWelcomeAutomatedMessageComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵelementStart(1, "fa-icon", 46);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_9_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(); return ctx_r62.closeAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "jhi-alert-error");
    i0.ɵɵelement(3, "coach-bio", 71);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("coach", ctx_r7.coach)("selectedCoachReasoning", ctx_r7.coachReasoning);
} }
function CoachWelcomeAutomatedMessageComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 72);
    i0.ɵɵelementStart(1, "fa-icon", 46);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_11_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelementStart(4, "div", 73);
    i0.ɵɵelement(5, "h3", 74);
    i0.ɵɵelement(6, "p", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 56);
    i0.ɵɵelementStart(8, "a", 76);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_11_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(); return ctx_r67.close(); });
    i0.ɵɵelement(9, "span", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 78);
    i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_ng_template_11_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r66); const ctx_r68 = i0.ɵɵnextContext(); return ctx_r68.deleteEducation(ctx_r68.educationToBeRemoved); });
    i0.ɵɵelement(11, "span", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
export class CoachWelcomeAutomatedMessageComponent extends BaseComponent {
    constructor(sessionStorage, modalService, languageService, automatedMessageService, fb, userService) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.languageService = languageService;
        this.automatedMessageService = automatedMessageService;
        this.fb = fb;
        this.userService = userService;
        this.onAutomatedMessageSubmit = new EventEmitter();
        this.onCoachReasoningSubmit = new EventEmitter();
        this.showWhyDoICoach = true;
        this.showMyExperience = true;
        this.showIcebreakers = true;
        this.showEducationCredentials = true;
        this.showWelcomeMessage = true;
        this.charLimitWhyDoICoach = 500;
        this.charLimitMyExperience = 1000;
        this.charLimitIcebreakers = 1000;
        this.charLimitWelcomeMessage = 2000;
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
        this.educationForm = this.fb.group({
            title: [''],
            school: [''],
            year: ['', Validators.minLength(4)],
        });
        this.LANGUAGES = LANGUAGES;
    }
    ngOnInit() {
        this.userService.findById(this.coachDto.coachId).subscribe((coach) => {
            this.coach = coach;
        });
        console.log(this.entityLanguage);
    }
    updateCoachBio() {
        console.log(this.automatedMessage);
        console.log(this.coachReasoning);
        let message = this.automatedMessage.text;
        if (message == null || message.length < 20) {
            this.openMessageTooShortModal();
        }
        else {
            this.submit();
        }
    }
    submit() {
        this.onCoachReasoningSubmit.next(this.coachReasoning);
        if (this.automatedMessage.coach != null) {
            this.automatedMessageService.update(this.automatedMessage).subscribe((result) => {
                this.close();
                this.onAutomatedMessageSubmit.next(result.body);
                this.openAlertModal("settings.headers.autoMessageUpdated");
            }, err => {
                this.close();
                console.log(err);
            });
        }
        else {
            let coach = new User();
            coach.id = this.coachDto.coachId;
            this.automatedMessage.coach = coach;
            this.automatedMessage.id = null;
            this.automatedMessageService.create(this.automatedMessage).subscribe((result) => {
                this.close();
                this.openAlertModal("settings.headers.autoMessageCreated");
                this.onAutomatedMessageSubmit.next(result.body);
            }, err => {
                this.close();
                console.log(err);
            });
        }
    }
    close() {
        this.modalService.dismissAll();
    }
    openMessageTooShortModal() {
        this.modalService.open(this.messageTooShortModal, this.modalOptions);
    }
    openAlertModal(message) {
        const modalRef = this.modalService.open(AlertModalComponent, this.modalOptions);
        modalRef.componentInstance.alertModalRef = modalRef;
        modalRef.componentInstance.language = this.languageService.getCurrentLanguage();
        modalRef.componentInstance.userAlertMessage = message;
    }
    getColor(text, charLimit) {
        return text != null && text.length > charLimit ? 'red' : '#7CBFAE';
    }
    openEducationModal() {
        this.coachEducation = new CoachEducation();
        this.modalService.open(this.educationModal, this.modalOptions).result.then((result) => console.log(result));
    }
    editEducation(education) {
        this.coachEducation = education;
        this.modalService.open(this.educationModal, this.modalOptions).result.then((result) => console.log(result));
    }
    confirmDeleteEducation(education) {
        this.educationToBeRemoved = education;
        this.modalService.open(this.educationDeletionConfirmation, { size: 'md', backdrop: 'static', centered: true });
    }
    deleteEducation(education) {
        let index = this.coachReasoning.educations.indexOf(education);
        this.coachReasoning.educations.splice(index, 1);
        this.close();
    }
    updateEducation() {
        this.educationForm.patchValue({
            title: this.coachEducation.title,
            school: this.coachEducation.school,
            year: this.coachEducation.year,
        });
        if (this.coachEducation.year.toString().length >= 4) {
            if (this.coachReasoning.educations.length === 0) {
                this.coachReasoning.educations.push(this.coachEducation);
                this.modalService.dismissAll();
            }
            else {
                for (let i = 0; i < this.coachReasoning.educations.length; i++) {
                    let e = this.coachReasoning.educations[i];
                    let ce = this.coachEducation;
                    if (e.title !== ce.title || e.school !== ce.school || e.year !== ce.year) {
                        this.coachReasoning.educations.push(this.coachEducation);
                        this.modalService.dismissAll();
                        break;
                    }
                    else {
                        this.openAlertModal('settings.alreadyEducation');
                    }
                }
            }
        }
        else {
            this.openAlertModal('register.messages.error.atLeast4');
            console.log(this.educationForm);
        }
        console.log(this.coachReasoning);
    }
    displayCoachBio() {
        this.modalService.open(this.coachBioModal, { size: 'lg', backdrop: 'static', centered: true });
    }
    closeAll() {
        this.modalService.dismissAll();
    }
}
CoachWelcomeAutomatedMessageComponent.ɵfac = function CoachWelcomeAutomatedMessageComponent_Factory(t) { return new (t || CoachWelcomeAutomatedMessageComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.JhiLanguageService), i0.ɵɵdirectiveInject(i4.AutomatedMessageService), i0.ɵɵdirectiveInject(i5.FormBuilder), i0.ɵɵdirectiveInject(i6.UserService)); };
CoachWelcomeAutomatedMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachWelcomeAutomatedMessageComponent, selectors: [["coach-welcome-automated-message"]], viewQuery: function CoachWelcomeAutomatedMessageComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coachBioModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.educationModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.educationDeletionConfirmation = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageTooShortModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.automatedMessageText = _t.first);
    } }, inputs: { entityLanguage: "entityLanguage", defaultAutomatedMessageText: "defaultAutomatedMessageText", automatedMessage: "automatedMessage", coachDto: "coachDto", coachReasoning: "coachReasoning" }, outputs: { onAutomatedMessageSubmit: "onAutomatedMessageSubmit", onCoachReasoningSubmit: "onCoachReasoningSubmit" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 2, consts: [[1, "d-flex", "justify-content-center"], ["class", "col-12 col-sm-12 col-md-10 col-lg-8 card automated-message-card mb-4", 4, "ngIf"], ["class", "d-flex justify-content-center", 4, "ngIf"], [1, "text-center", "automated-message-submit"], ["type", "button", "jhiTranslate", "settings.form.saveChanges", 1, "btn", "btn-primary", 3, "click"], ["messageTooShortModal", ""], ["educationModal", ""], ["coachBioModal", ""], ["educationDeletionConfirmation", ""], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-8", "card", "automated-message-card", "mb-4"], [1, "coach-bio-div"], [1, "d-flex", "justify-content-between", "align-items-top"], ["jhiTranslate", "settings.headers.whyDoICoach", 1, "mb-1"], [1, "angle-icon", "d-sm-none", 3, "click"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up-0A4A3A", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down-0A4A3A", 4, "ngIf"], ["class", "position-relative", 4, "ngIf"], ["jhiTranslate", "settings.headers.myExperience", 1, "mb-1"], ["jhiTranslate", "settings.headers.iceBreakers", 1, "mb-1"], ["jhiTranslate", "settings.headers.educationCredentials", 1, "mb-3"], [4, "ngIf"], ["jhiTranslate", "settings.headers.addEducationCertificate", 1, "add-education", 3, "click"], [1, "d-flex", "justify-content-center", "align-items-top", 2, "cursor", "pointer", "margin-top", "10px", 3, "click"], [1, "eye-icon"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#eye-44A38B"], ["jhiTranslate", "settings.headers.howCoacheeSees", 1, "add-education"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up-0A4A3A"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down-0A4A3A"], [1, "position-relative"], [1, "d-flex", "flex-column"], ["type", "text", "maxlength", "2000", 1, "form-control", "automated-text-area", 3, "placeholder", "ngModel", "ngModelChange"], [1, "indicator-div"], [1, "float-right", 3, "ngStyle"], ["type", "text", "maxlength", "1000", 1, "form-control", "automated-text-area", 3, "placeholder", "ngModel", "ngModelChange"], [4, "ngFor", "ngForOf"], [1, "span-tab", "m-1"], [1, "mt-2", "mr-1", "ml-1"], ["icon", "times-circle", 1, "remove-education", 3, "click"], [1, "mr-2", "ml-2", "mb-2", "coach-education-div", 3, "click"], [1, "mb-2", "coach-education-title"], [1, "mb-2", "coach-education-text"], [1, "coach-education-text"], ["jhiTranslate", "settings.headers.addWelcome", 1, "mb-1"], ["jhiTranslate", "settings.headers.coacheeGetsMessage", 1, "mb-4", "pale-text"], ["type", "text", "maxlength", "2000", 1, "form-control", "automated-text-area", 3, "ngModel", "ngModelChange"], [1, "olha-theme", "p-4"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [1, "font-weight-bold", "justify-content-start"], ["jhiTranslate", "settings.headers.autoMessageTooShort", 3, "translateValues"], [1, "d-sm-none"], [1, "text-center", "p-2"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["jhiTranslate", "sessionChat.button.continue"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"], ["jhiTranslate", "sessionChat.word.no"], [1, "d-flex", "justify-content-end"], [1, "d-none", "d-sm-block", "d-md-block", "d-lg-block", "d-xl-block"], ["id", "session-reschedule-confirm-btn", "type", "button", 1, "btn", "btn-primary", "m-2", 3, "click"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "m-2", 3, "click"], [1, "olha-theme"], ["jhiTranslate", "settings.headers.addEducation", 1, "mb-3"], ["name", "education", "role", "form", 3, "formGroup", "ngSubmit"], [1, "card", "form-card", "mb-4"], ["appearance", "outline"], ["matInput", "", "formControlName", "title", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "formControlName", "school", 3, "placeholder", "ngModel", "ngModelChange"], ["type", "number", "matInput", "", "formControlName", "year", 3, "placeholder", "ngModel", "ngModelChange"], [1, "text-center"], ["type", "submit", "jhiTranslate", "entity.action.save", 1, "btn", "btn-primary"], [1, "olha-theme", "p-2", "coach-bio"], [3, "coach", "selectedCoachReasoning"], [1, "olha-theme", "p-4", 2, "background-color", "white!important", "border-radius", "19px !important", "padding", "0!important"], [1, "justify-content-start"], ["jhiTranslate", "settings.confirmDeleteEducation"], ["jhiTranslate", "settings.confirmDeleteEducationDescription"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "m-2", 2, "text-decoration", "underline", "border", "none!important", 3, "click"], ["jhiTranslate", "entity.action.cancel"], ["type", "button", 1, "btn", "btn-primary", "m-2", 2, "width", "150px", 3, "click"], ["jhiTranslate", "entity.action.delete"]], template: function CoachWelcomeAutomatedMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CoachWelcomeAutomatedMessageComponent_div_1_Template, 34, 12, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, CoachWelcomeAutomatedMessageComponent_div_2_Template, 9, 3, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "button", 4);
        i0.ɵɵlistener("click", function CoachWelcomeAutomatedMessageComponent_Template_button_click_4_listener() { return ctx.updateCoachBio(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, CoachWelcomeAutomatedMessageComponent_ng_template_5_Template, 19, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, CoachWelcomeAutomatedMessageComponent_ng_template_7_Template, 30, 22, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, CoachWelcomeAutomatedMessageComponent_ng_template_9_Template, 4, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, CoachWelcomeAutomatedMessageComponent_ng_template_11_Template, 12, 0, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.coachReasoning);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.automatedMessage);
    } }, directives: [i7.NgIf, i8.JhiTranslateDirective, i5.DefaultValueAccessor, i5.MaxLengthValidator, i5.NgControlStatus, i5.NgModel, i7.NgStyle, i7.NgForOf, i9.FaIconComponent, i10.AlertErrorComponent, i5.ɵNgNoValidate, i5.NgControlStatusGroup, i5.FormGroupDirective, i11.MatFormField, i11.MatLabel, i12.MatInput, i5.FormControlName, i5.NumberValueAccessor, i13.CoachBioComponent], pipes: [i14.TranslatePipe], styles: [".coach-bio[_ngcontent-%COMP%]{min-height:600px;max-height:800px}coach-bio[_ngcontent-%COMP%]{overflow:scroll}.automated-text-area[_ngcontent-%COMP%]{border:1px solid #e1e1e1 !important;border-radius:10px !important;resize:none !important;color:#8a9d98 !important;overflow:scroll;font-family:Open Sans,serif;font-size:16px;font-style:normal;font-weight:400;line-height:140%}.automated-text-area[_ngcontent-%COMP%]::-moz-placeholder{color:#8a9d98;font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:130%}.automated-text-area[_ngcontent-%COMP%]::placeholder{color:#8a9d98;font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:130%}.indicator-div[_ngcontent-%COMP%]{line-height:1.2;margin-top:3px !important;position:relative;bottom:30px;right:15px}.automated-message-card[_ngcontent-%COMP%]{padding:20px !important}.coach-bio-div[_ngcontent-%COMP%]{margin-bottom:20px}.automated-message-card[_ngcontent-%COMP%]{padding:30px !important}.pale-text[_ngcontent-%COMP%]{color:#8a9d98;font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:140%}.add-education[_ngcontent-%COMP%]{color:var(--scan-result-green, #44A38B);font-family:Poppins,serif;font-size:16px;font-style:normal;font-weight:700;line-height:110%;-webkit-text-decoration-line:underline;text-decoration-line:underline;cursor:pointer;margin-top:5px}.close[_ngcontent-%COMP%]{cursor:pointer !important;float:right;margin-top:15px;margin-right:15px}.main-body[_ngcontent-%COMP%]{padding:35px}.angle-icon[_ngcontent-%COMP%]{height:24px;width:24px;cursor:pointer}.eye-icon[_ngcontent-%COMP%]{height:17px;width:24px}.span-tab[_ngcontent-%COMP%]{border-radius:10px;border:1px solid var(--text-green-light-text, #8A9D98);background:var(--fill-background-white, #FFF);height:125px;font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%;display:inline-grid}.remove-education[_ngcontent-%COMP%]{font-size:16px;float:right;color:#8a9d98;cursor:pointer}.coach-education-title[_ngcontent-%COMP%]{color:#0a4a3a;font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.coach-education-text[_ngcontent-%COMP%]{color:var(--text-dark-green, #0A4A3A);font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400}.coach-education-div[_ngcontent-%COMP%]{overflow-x:clip;overflow-y:scroll;cursor:pointer}  .mat-radio-button,   .mat-form-field,   .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}  .mat-radio-button.mat-accent .mat-radio-inner-circle,   .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),   .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple,   .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle,   .mat-radio-outer-circle{border-color:#44a38d}  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}  .olha-theme .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}  .mat-form-field-wrapper{padding-bottom:16px !important}"] });
